import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Gavel } from "lucide-react";

export function HistorialFaltasRit({ vid }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const interno = ["admin", "gestor"].includes(user?.role);
  useEffect(() => {
    if (interno) api.get(`/vinculaciones/${vid}/faltas-rit`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [vid, interno]);
  if (!interno || !items) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="historial-faltas-rit">
      <div className="mb-1 flex items-center gap-2">
        <Gavel className="h-4 w-4 text-vino-700" />
        <h3 className="text-base font-semibold text-slate-800">Faltas del Reglamento invocadas</h3>
        <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600" data-testid="historial-faltas-total">{items.length}</span>
      </div>
      <p className="mb-3 text-xs text-slate-400">Uso interno de HUMAN. Incluye todas las vinculaciones de esta persona.</p>
      {items.length === 0 ? <p className="text-sm text-slate-500" data-testid="historial-faltas-vacio">No se han invocado faltas del Reglamento Interno de Trabajo.</p> : (
        <div className="divide-y divide-slate-100">
          {items.map((x) => (
            <button key={x.terminacion_id} onClick={() => navigate(`/contrataciones/terminaciones/${x.terminacion_id}`)} data-testid={`falta-rit-${x.terminacion_id}`}
              className="flex w-full flex-col gap-0.5 py-2.5 text-left transition-colors hover:bg-slate-50">
              <span className="text-sm font-medium text-slate-800">Art. {x.articulo_rit} · {x.texto_rit}</span>
              <span className="text-xs text-slate-500">
                {x.origen} · {x.fecha} · {x.estado_label}{x.rit_version ? ` · RIT versión ${x.rit_version}` : ""}{x.empresa_usuaria ? ` · ${x.empresa_usuaria}` : ""}{!x.misma_vinculacion ? " · otra vinculación" : ""}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
